const type = 'advanced'
const path = 'server/nodejs/react'
const name = 'server.js'
const fullPath = `${path}/${name}`

const conditions = [
  {
    option: 'frontend',
    value: 'react',
  },
]

export { type, path, name, fullPath, conditions }
